<template>
	<b-container fluid>
		<b-card
			class="mx-2 my-4"
			header="Censo da Casa da Gestante"
			header-text-variant="white"
			header-tag="header"
			header-bg-variant="success"
			footer-tag="footer"
		>
			<b-card-text>
				<b-row>
					<b-col>
						<b-table
							id="tabelaCenso"
							:items="myProvider"
							:per-page="perPage"
							:current-page="currentPage"
							:fields="campos_tabela"
							:filter="filtro"
							small
						>
							<template v-slot:cell(dthr_internacao)="data">
								<!-- `data.value` is the value after formatted by the Formatter -->
								<p v-if="data.value">
									{{
										new Date(data.value)
											| moment("DD/MM/YYYY")
									}}
								</p>
							</template>

							<template v-slot:cell(acoes)="row">
								<!-- `data.value` is the value after formatted by the Formatter -->
								<b-row align-h="end" class="mr-1">
									<!-- <b-button size="sm" variant="primary" @click="exibeEscala(row.item.id)">
                    <b-icon icon="search"></b-icon>
                  </b-button>-->

									<b-button
										size="sm"
										class="ml-2"
										variant="success"
										:to="
											`censo/internar/${row.item.id}?internar=true`
										"
										v-b-tooltip.hover
										title="Registrar entrada"
										v-show="!row.item.dthr_internacao"
									>
										<b-icon
											icon="box-arrow-in-down-right"
										></b-icon>
									</b-button>
									<b-button
										size="sm"
										class="ml-2"
										variant="danger"
										:to="`censo/editar/${row.item.id}`"
										v-b-tooltip.hover
										title="Registrar saída"
										v-show="row.item.nome"
									>
										<b-icon
											icon="box-arrow-up-right"
										></b-icon>
									</b-button>
									<b-button
										size="sm"
										class="ml-2"
										variant="warning"
										:to="`censo/editar/${row.item.id}`"
										v-b-tooltip.hover
										v-show="row.item.nome"
										title="Editar"
									>
										<b-icon icon="pencil"></b-icon>
									</b-button>
								</b-row>
							</template>
						</b-table>
					</b-col>
				</b-row>
				<b-row>
					<b-col class="d-flex justify-content-center">
						<b-pagination
							v-model="currentPage"
							:total-rows="totalRows"
							:per-page="perPage"
							size="sm"
							class="my-0"
						></b-pagination>
					</b-col>
				</b-row>
			</b-card-text>
		</b-card>
	</b-container>
</template>

<script>
import mixinToast from "@/mixins/mixinToast.js";
import permissionsMixin from "@/mixins/permissionsMixin.js";

export default {
	mixins: [mixinToast, permissionsMixin],
	data() {
		return {
			escala: null,
			currentPage: 1,
			perPage: 5,
			totalRows: 0,
			filtro: "",
			campos_tabela: [
				{ key: "id", label: "ID" },
				{ key: "descricao_dormitorio", label: "Dormitório" },
				{ key: "nome", label: "Usuária" },
				{ key: "diagnostico", label: "Diagnóstico" },
				{ key: "descricao_perfil", label: "Perfil" },
				{ key: "dthr_internacao", label: "Data Internação" },
				{ key: "observacao", label: "Observação" },
				{ key: "acoes", label: "Ações", thClass: "cabecalho-direita" },
			],
		};
	},
	methods: {
		myProvider(ctx) {
			return this.$http
				.get("/censo?filter=" + ctx.filter)
				.then((result) => {
					return result.data;
				});
		},
	},
};
</script>

<style>
.cabecalho-direita {
	text-align: right;
	padding-right: 0.9rem !important;
}
/* .modal {
  padding: 0 !important;
}
.modal .modal-dialog {
  width: 100%;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal .modal-body {
  overflow-y: auto;
} */
</style>
